/**
 * Text-to-Speech Accessibility Feature
 * Toggle with Ctrl+S
 * Extracted from theme.liquid for performance optimization
 */

(function() {
  'use strict';

  let voiceAssistEnabled = localStorage.getItem('voiceAssistEnabled');
  let speechEnabled = voiceAssistEnabled === 'true';
  let welcomeTextSpeakCount = 0;
  let lastSpokenText = "";
  let timeoutId;
  
  const pageName = window.location.pathname;
  const productSinglePage = 'https://getboldify.com/products/';

  // Check if speech synthesis is supported
  if (!window.speechSynthesis) {
    console.error("Sorry, your browser doesn't support text-to-speech functionality.");
    return;
  }

  function debounce(func, delay) {
    let timeout;
    return function (...args) {
      const context = this;
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(context, args), delay);
    };
  }

  function setTabindexToAttribute(elements) {
    setTimeout(() => {
      elements.forEach((el) => {
        if (el) {
          el.setAttribute("tabindex", "0");
        }
      });
    }, 4000);
  }

  function speakText(target, textString, descriptionString) {
    if (!window.speechSynthesis) {
      console.error("Speech synthesis not supported.");
      return;
    }
    window.speechSynthesis.cancel();
    let text = '';
    if (target) {
      if (target instanceof HTMLElement) {
        text = target.getAttribute('aria-label') || target.innerText.trim();
      } else {
        text = "";
      }
    } else {
      text = textString;
    }

    if (!text) return;

    if (descriptionString) {
      text += text ? `, ${descriptionString}` : descriptionString;
    }

    clearTimeout(timeoutId);

    timeoutId = setTimeout(() => {
      let utterance = new SpeechSynthesisUtterance(text);
      utterance.onerror = (event) => {
        console.error('Speech synthesis error:', event);
      };
      window.speechSynthesis.speak(utterance);
      lastSpokenText = text;
    }, 100);
  }

  function getProductPrice(priceContainer) {
    const regularPriceElement = priceContainer.querySelector('.price__regular .price-item--regular');
    const salePriceRegularElement = priceContainer.querySelector('.price__sale .price-item--regular');
    const salePriceElement = priceContainer.querySelector('.price__sale .price-item--sale');

    let priceText = '';

    if (salePriceRegularElement && salePriceElement) {
      const regularPrice = salePriceRegularElement.textContent.trim() || '';
      const salePrice = salePriceElement.textContent.trim() || '';

      if (regularPrice) {
        priceText = `Regular Price: ${regularPrice}, Sale Price: ${salePrice}`;
      } else {
        priceText = `Sale Price: ${salePrice}`;
      }
    } else if (regularPriceElement) {
      const regularPrice = regularPriceElement.textContent.trim() || '';
      priceText = `Regular Price: ${regularPrice}`;
    }

    return priceText;
  }

  function sortByAccessibility() {
    function applyAriaAttributes(selectElement) {
      if (selectElement) {
        selectElement.setAttribute("aria-label", "Sort by");
        selectElement.setAttribute("tabindex", "0");
      }
    }

    function handleSortSelect() {
      const sortSelect = document.getElementById("SortBy");
      if (!sortSelect) return;

      applyAriaAttributes(sortSelect);

      sortSelect.addEventListener("focus", function () {
        applyAriaAttributes(sortSelect);
        speakText(null, "Sort products by. Currently selected: " + this.options[this.selectedIndex].text);
      });

      sortSelect.addEventListener("change", function () {
        speakText(null, "Sorting by " + this.options[this.selectedIndex].text);
        applyAriaAttributes(this);
        setTimeout(() => {
          applyAriaAttributes(this);
        }, 1000);
      });

      sortSelect.addEventListener("keydown", function (event) {
        if (event.key === "ArrowUp" || event.key === "ArrowDown") {
          setTimeout(() => {
            applyAriaAttributes(this);
            speakText(null, "Sorting by " + this.options[this.selectedIndex].text);
          }, 100);
        }
      });
    }

    const observer = new MutationObserver(() => {
      handleSortSelect();
    });

    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(handleSortSelect, 2000);
  }

  function handleSpeechEvent(event) {
    if (!speechEnabled) return;

    const target = event.target;
    const tagName = target.tagName.toUpperCase();
    const textContent = target.innerText?.trim() || "";

    const ignoredTags = ['HTML', 'BODY', 'MAIN', 'HEADER', 'STICKY-HEADER', 'PRODUCT-INFO', 'FIELDSET', 'NAV', 'SELECT', 'SLIDER-COMPONENT', 'CART-ITEMS', 'FOOTER'];
    const ignoredClasses = [
      'announcement-bar', 'collection', 'product-grid-container', 'facets-container', 'facets__summary',
      'facet-filters', 'product__info-wrapper', 'octane-ai-quiz-rendered', 'c-embeddedWidget',
      'c-actionCard', 'okeLoyalty', 'c-okeReferralsApp', 'page-width', 'register',
      'section-template--18196762820830__product-grid-padding', 'oke-w-header-content',
      'oke-w-header-content-block', 'okeReviews', 'oke-w-reviews', 'login', 'cart__footer',
      'route-div', 'footer-block--newsletter', 'alchemy__element', 'r-17l1fbm', 'r-1foci4v',
      'r-17sngmt', 'r-irtomz', 'r-1msjj7w', 'r-1efi14b', 'r-1nvzj1h', 'r-1vxj7la',
      'r-1orhzo6', 'r-yvxe1l', 'r-eahfw3', 'r-10gfenn', 'r-1ng6msc', 'r-koq4af',
      'r-56cbes', 'r-hudmdb', 'r-1413ox2', 'r-116y4rh', 'oke-w-breakdownModule-distribution',
      'js-oke-widgetSize', 'oke-w-reviews-head', 'footer__list-social', 'MegaMenu-Content-1',
      'strmpr-field-name', 'section-template--18450853429470__custom_liquid_jXrDHU-padding'
    ];

    const ignoredIds = [
      'shopify-section-template--18196763246814__1727286056a8789950',
      'shopify-section-template--18196763541726__main',
      'ProductSubmitButton-template--18196763246814__main',
      'customer-login', 'main-cart-footer',
      'shopify-section-template--18578221990110__1735127952152e55a5'
    ];

    if (target.id && ignoredIds.includes(target.id)) return;

    if (
      ignoredTags.includes(tagName) ||
      (tagName === 'DIV' &&
        (target.classList.length === 0 ||
          ignoredClasses.some(cls => target.classList.contains(cls)) ||
          (target.id && ignoredIds.includes(target.id.trim())))) ||
      (tagName === 'SECTION' && target.classList.contains('product__info-container'))
    ) {
      return;
    }

    if (tagName === 'A') {
      let parentLi = target.closest('li');
      if (parentLi) {
        let descriptionString = getProductPrice(parentLi);
        speakText(target, null, descriptionString);
      }
    } else if (tagName === 'SVG' && target.classList.contains('icon-account')) {
      speakText(null, 'Login');
    } else if (tagName === 'SVG' && target.classList.contains('icon-search')) {
      speakText(null, 'Search');
    } else if (tagName === 'SVG' && (target.classList.contains('icon-cart') || target.classList.contains('icon-cart-empty'))) {
      speakText(null, 'Cart');
    } else if (tagName === 'SPAN' && target.classList.contains('accessibly-app-icon-logo')) {
      speakText(null, 'accessibly settings');
    } else {
      if (target.hasAttribute('aria-label') || textContent.length > 0) {
        speakText(target);
      }
    }
  }

  function initPageSpecificAccessibility() {
    setTimeout(() => {
      const emailInput = document.querySelector(".newsletter-form__field-wrapper input[type='email']");
      if (emailInput) emailInput.setAttribute("aria-label", "Enter your email address");

      const priceGTE = document.querySelector("#Filter-Price-GTE");
      if (priceGTE) priceGTE.setAttribute("aria-label", "From");

      const priceLTE = document.querySelector("#Filter-Price-LTE");
      if (priceLTE) priceLTE.setAttribute("aria-label", "To");

      setTimeout(() => {
        const elements = document.querySelectorAll(".news-message span, .text-slider-section, .banner__heading, .cart-notification__heading, .cart-notification-product, .pw-coverage-description-default, .copyright__content");
        setTabindexToAttribute(elements);
      }, 3000);
    }, 2000);

    // Page-specific accessibility enhancements
    if (pageName === "/pages/contact-us") {
      setTabindexToAttribute(document.querySelectorAll(".rich-text__heading, .rich-text__text, .image-with-text__heading"));
    } else if (pageName === "/pages/our-story" || pageName === "/pages/about-us") {
      setTabindexToAttribute(document.querySelectorAll(".custom-content-text, .image-with-text__heading, .image-with-text__text"));
    } else if (pageName === "/blogs/style-advice") {
      setTabindexToAttribute(document.querySelectorAll(".article-card__info, .article-card__excerpt"));
    } else if (pageName === "/pages/bold-acts") {
      setTabindexToAttribute(document.querySelectorAll(".image-with-text__heading, .image-with-text__text, .rich-text__heading, .rich-text__text, .multicolumn-card__info"));
    } else if (pageName === "/pages/formulas") {
      setTabindexToAttribute(document.querySelectorAll(".rich-text__text, .image-with-text__heading, .image-with-text__text"));
    } else if (pageName === "/pages/store-locator") {
      setTabindexToAttribute(document.querySelectorAll(".banner__heading, .banner__text, .rich-text__heading, .rich-text__text, .image-with-text__heading, .strmpr-product-title"));
    } else if (pageName === "/pages/hair-quiz") {
      setTimeout(() => {
        const quizTitle = document.querySelector('[data-element="oct-quiz-text oct-quiz-title"]');
        if (quizTitle) quizTitle.setAttribute("tabindex", "0");
        const quizSubheading = document.querySelector('[data-element="oct-quiz-text oct-quiz-subheading"]');
        if (quizSubheading) quizSubheading.setAttribute("tabindex", "0");
      }, 2000);
    } else if (pageName === "/pages/loyalty") {
      setTimeout(() => {
        setTabindexToAttribute(document.querySelectorAll(".c-embeddedHeaderBar-title, .u-textStyle--title, .c-loginForm-label, .u-textStyle--subtitle, .u-textStyle--body, .c-headerText-title, .c-input, c-terms"));
        const emailInput = document.querySelector("#referralSenderEmail");
        if (emailInput) emailInput.setAttribute("aria-label", "Enter email address");
        const referralSenderName = document.querySelector("#referralSenderName");
        if (referralSenderName) referralSenderName.setAttribute("aria-label", "Your Name optional");
      }, 3000);
    } else if (pageName === "/account/login") {
      setTabindexToAttribute(document.querySelectorAll("#recover, .customer div p"));
      const emailInput = document.querySelector("#CustomerEmail");
      const RecoverEmail = document.querySelector("#RecoverEmail");
      if (emailInput) emailInput.setAttribute("aria-label", "Enter your email address");
      if (RecoverEmail) RecoverEmail.setAttribute("aria-label", "Enter your email address");
      const customerPassword = document.querySelector("#CustomerPassword");
      if (customerPassword) customerPassword.setAttribute("aria-label", "Enter your email password");
    } else if (pageName === "/account/register") {
      setTabindexToAttribute(document.querySelectorAll(".customer h1"));
      const firstName = document.querySelector("#RegisterForm-FirstName");
      if (firstName) firstName.setAttribute("aria-label", "Enter your first name");
      const lastName = document.querySelector("#RegisterForm-LastName");
      if (lastName) lastName.setAttribute("aria-label", "Enter your last name");
      const emailInput = document.querySelector("#RegisterForm-email");
      if (emailInput) emailInput.setAttribute("aria-label", "Enter your email address");
      const password = document.querySelector("#RegisterForm-password");
      if (password) password.setAttribute("aria-label", "Enter your email password");
    } else if (pageName === "/pages/faqs") {
      setTabindexToAttribute(document.querySelectorAll(".accordion p, .image-with-text__heading"));
    } else if (pageName === "/") {
      setTabindexToAttribute(document.querySelectorAll(".banner__text, .rich-text__text, .rich-text__heading"));
    } else if (window.location.href.includes(productSinglePage)) {
      setTabindexToAttribute(document.querySelectorAll(".tab-popup-content, .price__container, .halo-block-header, .oke-w-recommendsModule, .oke-w-ratingAverageModule-count, .oke-w-ratingAverageModule-rating-average, .oke-w-reviews-list-item, .form__label, fieldset label, .price__badge-sale, .price__badge-sold-out"));
    } else if (["/collections/rinse", "/collections/treat", "/collections/enhance", "/collections/big-volume-styling", "/collections/tools", "/collections/kits-bundles", "/collections/healthy-hair-growth", "/collections/hair-volume-thickness", "/collections/conceal-hair-loss"].includes(pageName)) {
      setTabindexToAttribute(document.querySelectorAll(".image-with-text__heading, .image-with-text__text"));
    } else if (pageName === "/pages/top-picks") {
      setTabindexToAttribute(document.querySelectorAll(".image-with-text__heading, .banner__text"));
    } else if (pageName === "/cart") {
      setTabindexToAttribute(document.querySelectorAll(".cart__empty-text, .cart__login-title, .title--primary, .cart-item__details, .totals, .tax-note, .price.price--end"));
    } else if (pageName === "/pages/privacy") {
      setTabindexToAttribute(document.querySelectorAll(".policy-header, .iub_content"));
    } else if (pageName === "/pages/amazon-affiliate") {
      setTabindexToAttribute(document.querySelectorAll(".r-1foci4v p, .r-17sngmt p, .r-irtomz p, .r-1vxj7la p, .r-1isgwus, .r-n7fbw8 p, .r-1orhzo6 p, .r-yswxme p, .r-134fpmc p, .r-1qbqe57 p"));
    } else if (pageName === "/pages/earn-with-boldify") {
      setTabindexToAttribute(document.querySelectorAll(".r-a6jv2v p, .r-3uhcd4 p, .r-1xzoj2c p, .r-1m6rrn8 p, .r-1413ox2 p, .r-1qrn9eh p, .r-fkbw9s p, .r-264cjo p, .r-urxa3g p, .r-1mfodwm p, .r-1mavtqp p, .r-4kwpo1 p, .r-1a480kl p, .r-1xvraed p, .r-1cupeom p, .r-8g80ze p, .r-1mi6fbt p, .r-1udwcaz p, .r-16j2fdz p, .r-1y3hoj3 p"));
    }
  }

  function initTabNavigation() {
    const welcomeText = "Press Ctrl+S to toggle speech synthesis on and off.";

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Tab') {
        if (speechEnabled) {
          setTimeout(() => {
            let target = document.activeElement;
            let tagName = target.tagName.toUpperCase();

            if (!target.offsetParent) {
              if (target.hasAttribute("aria-label")) {
                speakText(target);
              }
              return;
            }

            if (tagName === 'BODY') return;

            let descriptionString = '';
            if (tagName === 'A' || tagName === 'SUMMARY') {
              if (tagName === 'A') {
                let parentLi = target.closest('li');
                if (parentLi) {
                  descriptionString = getProductPrice(parentLi);
                }
              }

              let textToSpeak = target?.textContent?.trim() || '';
              if (textToSpeak) {
                speakText(target, null, descriptionString);
              } else if (target.hasAttribute('aria-label')) {
                speakText(target, null, descriptionString);
              }
            } else if (['BUTTON', 'INPUT', 'TEXTAREA', 'SPAN'].includes(tagName) && target.hasAttribute('aria-label')) {
              speakText(target);
            } else if (tagName === 'SUMMARY' && target.hasAttribute('aria-label')) {
              speakText(target);
            } else if (tagName === 'DIV' && target.hasAttribute('aria-label')) {
              speakText(target);
            } else if (tagName === 'SHOP-PAY-WALLET-BUTTON') {
              speakText(null, 'shop pay wallet button');
            } else if (tagName === 'SHOP-LOGIN-BUTTON') {
              speakText(null, 'shop login button');
            } else if (tagName === 'SHOPIFY-GOOGLE-PAY-BUTTON') {
              speakText(null, 'shopify google pay button');
            } else if (tagName === 'DIV' && target.id && target.id === 'mcforms-222-351') {
              // popup - skip
            } else {
              const ignoredTags = ['SELECT'];
              if (ignoredTags.includes(tagName)) return;

              const textToSpeak = target?.textContent?.trim() || '';
              if (textToSpeak) {
                speakText(target);
              }
            }
          }, 50);
        } else {
          welcomeTextSpeakCount++;
          if (welcomeTextSpeakCount < 3) {
            speakText(null, welcomeText);
          }
        }
      }
    });
  }

  // Ctrl+S toggle handler
  document.addEventListener('keydown', function (event) {
    if (event.ctrlKey && event.key === 's') {
      event.preventDefault();
      let voiceAssistEnabled = localStorage.getItem('voiceAssistEnabled');

      if (voiceAssistEnabled) {
        speechEnabled = voiceAssistEnabled === 'true' ? false : true;
      } else {
        speechEnabled = !speechEnabled;
      }

      localStorage.setItem('voiceAssistEnabled', speechEnabled);
      let message = speechEnabled ? 'Speech synthesis enabled.' : 'Speech synthesis disabled.';
      speakText(null, message);
    }
  });

  // Event listeners
  document.addEventListener('mouseover', debounce(handleSpeechEvent, 300));
  document.addEventListener('click', handleSpeechEvent);

  document.addEventListener('focus', (event) => {
    if (speechEnabled) {
      const target = event.target;
      if (target && target.hasAttribute('aria-label')) {
        speakText(target);
      }
    }
  });

  document.addEventListener('mouseout', () => {
    lastSpokenText = "";
  });

  document.addEventListener('mouseleave', () => {
    clearTimeout(timeoutId);
    window.speechSynthesis.cancel();
  });

  // Initialize
  sortByAccessibility();
  initPageSpecificAccessibility();
  initTabNavigation();

})();
